/** Circle analytics taxonomy (M1-S10). */
export const CircleAnalyticsEventName = {
  LANDING_VIEW: 'circle.landing_view',
  JOIN: 'circle.join',
  SUBSCRIBE: 'circle.subscribe',
  CANCEL: 'circle.cancel',
  POST: 'circle.post',
  REACT: 'circle.react',
  BROADCAST: 'circle.broadcast',
} as const;

export type CircleAnalyticsEventNameValue =
  (typeof CircleAnalyticsEventName)[keyof typeof CircleAnalyticsEventName];

export const CIRCLE_ANALYTICS_EVENT_NAMES = Object.values(CircleAnalyticsEventName);

export function isCircleAnalyticsEventName(value: string): value is CircleAnalyticsEventNameValue {
  return (CIRCLE_ANALYTICS_EVENT_NAMES as readonly string[]).includes(value);
}
